import React from "react";
import { useTranslation } from "react-i18next";

import { useFormatCurrency } from "@krea/common/hooks";
import { settings } from "@krea/common/settings";
import TextInput from "@krea/common/shared-components/fields/input";
import { FormatNumber } from "@krea/common/shared-components/loan-application-form/Formatters";

const LeasingAmount = ({ value, name, error, ...rest }) => {
  const { t } = useTranslation();
  const currency = settings.currency;
  const [formattedCurrencyValue, currencyValue] = useFormatCurrency({
    currency,
  });

  return (
    <TextInput
      type="text"
      inputMode="numeric"
      autoComplete="off"
      name={name}
      label={t("applicationForm.leasing.fields.amount.label")}
      value={value ? FormatNumber(value) : ""}
      placeholder={t("applicationForm.leasing.fields.amount.placeholder", {
        currency: currencyValue,
      })}
      textAppend={currencyValue}
      error={error}
      {...rest}
    />
  );
};

export default LeasingAmount;
